import gql from "graphql-tag";

export const UPDATE_USER_BIRTHDATE_MUTATION = gql`
  mutation UpdateUserBirthDate($birthdate: String!) {
    updateUserBirthDate(birthdate: $birthdate)
  }
`;
